import axiosInstance from "./axiosConfig";

const API_URL = "/api/invoices";

const getAllInvoices = async (search = "") => {
  const params = {};
  if (search) params.search = search;
  const response = await axiosInstance.get(API_URL, { params });
  return response.data;
};

const getInvoiceById = async (id) => {
  const response = await axiosInstance.get(`${API_URL}/${id}`);
  return response.data;
};

const createInvoice = async (invoiceData) => {
  const response = await axiosInstance.post(API_URL, invoiceData);
  return response.data;
};

const updateInvoice = async (id, invoiceData) => {
  const response = await axiosInstance.put(`${API_URL}/${id}`, invoiceData);
  return response.data;
};

const deleteInvoice = async (id) => {
  const response = await axiosInstance.delete(`${API_URL}/${id}`);
  return response.data;
};

const exportInvoicesPdf = async () => {
  const response = await axiosInstance.get(`${API_URL}/export/pdf`, {
    responseType: "blob",
  });
  return response.data;
};

const invoiceService = {
  getAllInvoices,
  getInvoiceById,
  createInvoice,
  updateInvoice,
  deleteInvoice,
  exportInvoicesPdf,
};

export default invoiceService;
